import Typography from '@material-ui/core/Typography'
import CheckCircleIcon from '@material-ui/icons/CheckCircle'

import { getTranslate } from '../../../../localization'
import useStyles from './index.styles'

const PasswordComplexity = () => {
  const classes = useStyles()

  const rules = [
    'Minimum 6 and maximum 20 characters required',
    'Contain at least 2 special characters (!@#$%^&*)',
    'May contain any other characters (letters and numbers are allowed)'
  ]

  return (
    <div className={classes.root}>
      <Typography variant="h4" className={classes.header}>
        {getTranslate('Password Complexity')}
      </Typography>
      <div className={classes.subTitle}>
        {getTranslate('Current password policy requirements (read-only)')}
      </div>
      <div className={classes.listContainer}>
        {rules.map((rule) => (
          <div key={rule} className={classes.item}>
            <CheckCircleIcon className={classes.icon} />
            <Typography className={classes.text}>
              {getTranslate(rule)}
            </Typography>
          </div>
        ))}
      </div>
    </div>
  )
}

export default PasswordComplexity
